import styled from 'styled-components'

export default styled.footer`
	display: none;
`
